import { useState } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { history } from "../../../_config";
import { createSession } from "../../../_store/_actions/auth.actions";

import bigCommunitySvg from "../../../_assets/vectors/big-community.svg";
import joinCommunitySvg from "../../../_assets/vectors/join-community.svg";
import smallGroupSvg from "../../../_assets/vectors/small-group.svg";

import { withToast } from "../../../contexts/toastr.context";
import { getAuthUrl } from "../../../_config/helper.config";
import { mixPanel } from "../../../_config/mixpanel.config";
import I18 from "../../atoms/i18";

const CommunityTypeSelectionComponent = ({
  user,
  selectedType,
  setSelectedType,
  community,
  setUser,
  addToast = (e) => {},
}) => {
  const [visible, setVisible] = useState(true);

  const onSelectPlan = (value) => {
    setSelectedType(value);
  };

  return (
    <>
      {visible ? (
        <div
          className="CommunityTypeSelection theme-bg-default "
          style={{
            position: "fixed",
            top: 0,
            bottom: 0,
            left: 0,
            right: 0,
            zIndex: 900,
          }}>
          <div className="h-screen flex items-center justify-center">
            <div>
              <div className="mb-12 text-center">
                <p className=" font-semibold">
                  How are you planning to use Pensil?
                </p>
                <p className="theme-text-subtitle-2 mt-2">
                  We'll set up your community accordingly
                </p>
              </div>
              <div className="flex overflow-auto h-96 w-screen md:80vw md:justify-center md:h-96">
                <div
                  className={`theme-bg-surface ml-6 rounded-md cursor-pointer flex-shrink-0 overflow-auto	 ${
                    selectedType === "free"
                      ? "w-72 border border-blue-600"
                      : "w-64 border"
                  }`}
                  onClick={() => onSelectPlan("free")}>
                  <img
                    className="h-52 m-auto w-full"
                    src={smallGroupSvg}
                    alt=""
                  />
                  <div className="text-center"> 🚁 Small Group</div>
                  <div className="pt-2 pb-2">
                    <p
                      className={`text-center text-xs theme-text-subtitle-2 mt-2 ${
                        selectedType === "free" ? "mx-12" : "mx-5 "
                      }`}>
                      <I18>Organize better, create your own space</I18>
                    </p>
                  </div>
                  <div
                    className={`text-center text-sm mt-8 ${
                      selectedType === "free" ? "text-blue-600" : ""
                    }`}>
                    <I18>Free for 10000 Members</I18>
                  </div>
                </div>
                <div className="mr-5" />
                <div
                  className={`theme-bg-surface ml-6 mr-6 rounded-md cursor-pointer flex-shrink-0 overflow-auto ${
                    selectedType === "paid"
                      ? "w-72 border border-blue-600"
                      : "w-64 border"
                  }`}
                  onClick={() => onSelectPlan("paid")}>
                  <img
                    className="h-52 m-auto w-full"
                    src={bigCommunitySvg}
                    alt=""
                  />
                  <div className="text-center">
                    🚀 <I18> Big Community</I18>
                  </div>

                  <div className="pt-2 pb-2">
                    <p
                      className={`pl-1 pr-1 text-center text-xs theme-text-subtitle-2 mt-2 ${
                        selectedType === "paid" ? "mx-8" : "mx-5"
                      }`}>
                      Chat, collaborate, engage others. Embed in your
                      website/product.With Unlimited Members.
                    </p>
                  </div>
                  <div
                    className={`text-center text-sm mt-8 ${
                      selectedType === "paid" ? "text-blue-600" : ""
                    }`}>
                    Try for Free
                  </div>
                  <div className={"text-center text-xs mt-0.5"}>
                    (*Free for 30 days)
                  </div>
                </div>
                <div className="text-md self-center	mr-5">OR</div>
                {/* join a community */}
                <div
                  className={`theme-bg-surface rounded-md mr-6 cursor-pointer flex-shrink-0 overflow-auto	${
                    selectedType === "Join Community"
                      ? "w-72 border border-blue-600"
                      : "w-64 border"
                  }`}
                  onClick={() => {
                    history.push("/join-community");
                  }}>
                  <img
                    alt=""
                    className="h-52 m-auto w-full"
                    src={joinCommunitySvg}
                  />
                  <div className="text-center"> 🛵 Join Community</div>
                  <div className="pt-2 pb-2">
                    <p
                      className={`pl-1 pr-1 text-center text-xs theme-text-subtitle-2 mt-2 ${
                        selectedType === "Join Community" ? "mx-8" : "mx-5 "
                      }`}>
                      Find other intersting communities to join.
                    </p>
                  </div>
                  <div
                    className={`text-center text-sm mt-8 ${
                      selectedType === "Join Community" ? "text-blue-600" : ""
                    }`}>
                    Join for Free
                  </div>
                </div>
              </div>
              {/* <div className="text-center mt-8">
                                <Button
                                    onClick={() => {
                                    }}

                                    disabled={communityTypeSelection === "" ? true : false}
                                    label="Proceed"
                                    className={`bg-theme-primary border-2 border-theme-primary focus:outline-none font-semibold px-24 py-1 rounded text-white ${communityTypeSelection === "" ? 'cursor-not-allowed' : ''}`} />
                            </div> */}
            </div>
          </div>
          <div className="text-center -mt-20">
            <div>
              <span className="text-gray text-sm">
                You're creating a community using{" "}
              </span>
              <span className="text-black font-semibold">
                {user.email ? user.email : user.mobile}
              </span>
            </div>
            <div>
              {/* let user login from other account */}
              <span className="text-gray text-sm">
                If you don't intend to set up a community, you can{" "}
              </span>
              <span
                onClick={() => {
                  // clear the session
                  localStorage.removeItem("pensil.user");
                  mixPanel.reset();
                  // redirect to main app to clear the session there as well
                  const port = window.location.port;
                  // redirect to authRedirectUrl of community, if available
                  if (community && community.authRedirectUrl) {
                    window.location.href = getAuthUrl(community);
                  } else {
                    window.location.href =
                      process.env.REACT_APP_CLIENT_URL +
                      (port ? ":" + port : "") +
                      "?action=logout&redirect=" +
                      window.location.origin;
                  }
                }}
                className="text-blue-600 text-sm cursor-pointer">
                {`login from another ${user.email ? "email" : "mobile number"}`}{" "}
              </span>
            </div>
          </div>
        </div>
      ) : (
        <></>
      )}
    </>
  );
};
export const CommunityTypeSelection = withToast(
  connect(
    (s) => ({ user: s.auth, community: s.community }),
    (d) =>
      bindActionCreators(
        {
          setUser: createSession,
        },
        d
      )
  )(CommunityTypeSelectionComponent)
);
